import {getCurrentInstance} from "vue";

export const useGtag = () => {
  const vm = getCurrentInstance().proxy
  return vm.$gtag;
}
